import { BaseBody } from '../BaseBody.js';
import { CssVars } from '../../../util/CssVars.js';

const glyphname = 'apostrofos';
const args = {};

export class Apostrofos extends BaseBody {
  constructor() {
    super(glyphname, args);
  }
}
